import React, {Component} from 'react';
class Nosub extends React.Component {
    
    render() {
  return <div className="">
      <div className="row mt-2"> 
      <div className="head-left">
          <h1 className="head-color">Sorry You Have No Subscription!</h1>
        
          <div class="mt-4"><a href="/" class="btn btn-primary">Back To Home</a></div>
          </div>
      <img className="my-img" src="/images/nosub.jpg"/>
     
      </div>
       
       
                
  </div>
}
}
export default Nosub;